import { Outlet, useParams } from 'react-router-dom';
import { useEffect, useContext } from 'react';
import { Spinner, Center } from '@chakra-ui/react';
import MerchantContext from '../contexts/MerchantContext';
import { useTRPC } from '../trpc/client';
import { useDeeplinkLogin } from '../hooks/useDeeplinkLogin';
import { useQuery } from "@tanstack/react-query";

export const Layout = () => {
  const trpc = useTRPC();
  const { setMerchant, merchant } = useContext(MerchantContext);
  const params = useParams<{ merchant: string }>();
  
  const queryOptions = trpc.merchants.get.queryOptions({ id: params.merchant! });
  
  const merchantCheck = useQuery({
    ...queryOptions,
    enabled: true,
  });
  const { isProcessing } = useDeeplinkLogin();

  useEffect(() => {
    if (merchantCheck.isPending) return;

    if (merchantCheck.data && params.merchant) setMerchant(merchantCheck.data);
    else window.location.replace('https://www.palomma.com/');
  }, [merchantCheck.data, merchantCheck.isPending, params.merchant, setMerchant]);

  if (!merchant?.id || merchantCheck.isPending || isProcessing) {
    return (
      <Center height="100vh">
        <Spinner size="xl" />
      </Center>
    );
  }

  return <Outlet />;
};

export default Layout;
